module.exports = __webpack_public_path__ + "img/redbeard.c99123ae.png";